// Shoppa wishlist v1. Private state lives only in memory; writes are never retried automatically.
const configNode = document.querySelector('[data-shoppa-wishlist-config]');
if (configNode && !window.ShoppaWishlist) {
  const config = JSON.parse(configNode.getAttribute('data-config'));
  const copy = config.copy;
  const endpoint = 'https://prenotazione-test.shoppa.ch/profilo-prova/shoppa-profilo-dati-fatture-20261102-1500.php?wishlist=1';
  let snapshot = null;
  let generation = 0;
  let busy = false;
  let readPromise = null;
  let readController = null;
  let postController = null;
  let metadataController = null;
  let renderGeneration = 0;
  let visibleCount = 12;
  const productCache = new Map();
  let noticeFrame = null;
  let notice = null;
  const digitId = /^[1-9][0-9]{0,19}$/;
  const handlePattern = /^[a-z0-9][a-z0-9-]{0,254}$/;
  const elements = selector => Array.from(document.querySelectorAll(selector));
  function rootPath() {
    const path = typeof config.root === 'string' ? config.root : '/';
    return path.startsWith('/') && !path.startsWith('//') && !/[?#\\]/.test(path) ? path.replace(/\/?$/, '/') : '/';
  }
  const profileUrl = rootPath() + 'pages/profilo';
  function announce(message, login = false) {
    if (!notice) {
      notice = document.createElement('div');
      notice.className = 'shoppa-wishlist-notice';
      notice.hidden = true;
      document.body.appendChild(notice);
    }
    if (noticeFrame !== null) cancelAnimationFrame(noticeFrame);
    notice.replaceChildren();
    notice.hidden = !message;
    if (!message) return;
    const text = document.createElement('p');
    text.setAttribute('role', 'status');
    text.setAttribute('aria-live', 'polite');
    text.setAttribute('aria-atomic', 'true');
    notice.appendChild(text);
    if (login) {
      const link = document.createElement('a');link.href = profileUrl;link.textContent = copy.loginButton;notice.appendChild(link);
    }
    const close = document.createElement('button');close.type = 'button';close.textContent = copy.close;
    close.addEventListener('click', () => { notice.hidden = true; });notice.appendChild(close);
    noticeFrame = requestAnimationFrame(() => { noticeFrame = null;if (notice?.isConnected) text.textContent = message; });
  }
  function validSnapshot(data) {
    if (!data || data.authenticated !== true || data.wishlist_version !== 1 || !Number.isSafeInteger(data.revision) || data.revision < 0 || data.revision > 2147483646 || !Array.isArray(data.items) || data.items.length > 100 || !/^[a-f0-9]{64}$/.test(data.csrf) || data.maximum_items !== 100) throw new Error('wishlist_invalid');
    const seen = new Set();
    for (const item of data.items) {
      if (!item || typeof item.product_id !== 'string' || !digitId.test(item.product_id) || typeof item.handle !== 'string' || !handlePattern.test(item.handle) || !Number.isSafeInteger(item.added_at) || item.added_at <= 0 || seen.has(item.product_id)) throw new Error('wishlist_invalid');
      seen.add(item.product_id);
    }
    return { revision: data.revision, items: data.items.map(item => ({ product_id: item.product_id, handle: item.handle, added_at: item.added_at })), csrf: data.csrf };
  }
  function updateHearts() {
    const ids = new Set(snapshot ? snapshot.items.map(item => item.product_id) : []);
    elements('[data-shoppa-wishlist-toggle]').forEach(button => {
      const selected = snapshot !== null && ids.has(button.dataset.productId);
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', (selected ? copy.remove : copy.add) + (button.dataset.productTitle ? ': ' + button.dataset.productTitle : ''));
      button.title = selected ? copy.remove : copy.add;
      const label = button.querySelector('[data-shoppa-wishlist-label]');
      if (label) label.textContent = selected ? copy.remove : copy.add;
      button.disabled = busy;
    });
    elements('[data-shoppa-wishlist-remove], [data-shoppa-wishlist-refresh], [data-shoppa-wishlist-more]').forEach(button => { button.disabled = busy; });
  }
  function reset() {
    generation += 1;
    renderGeneration += 1;
    readController?.abort();postController?.abort();metadataController?.abort();
    readController = null;postController = null;metadataController = null;
    readPromise = null;snapshot = null;busy = false;visibleCount = 12;productCache.clear();
    updateHearts();
    elements('[data-shoppa-wishlist-list]').forEach(list => list.replaceChildren());
    elements('[data-shoppa-wishlist-state]').forEach(state => { state.textContent = ''; });
    elements('[data-shoppa-wishlist-more]').forEach(button => { button.hidden = true; });
    elements('[data-shoppa-wishlist-panel]').forEach(panel => panel.removeAttribute('aria-busy'));
    announce('');
  }
  async function responseJson(response) {
    if (!(response.headers.get('content-type') || '').includes('application/json')) throw new Error('wishlist_unavailable');
    const raw = await response.text();
    if (raw.length > 131072) throw new Error('wishlist_unavailable');
    return JSON.parse(raw);
  }
  function errorCode(data) {
    const allowed = ['wishlist_full', 'wishlist_conflict', 'wishlist_busy', 'wishlist_request_rejected'];
    return data && allowed.includes(data.error) ? data.error : 'wishlist_unavailable';
  }
  async function load(force = false) {
    if (readPromise && !force) return readPromise;
    if (force) readController?.abort();
    const version = generation;
    const controller = new AbortController();readController = controller;
    const timer = setTimeout(() => controller.abort(), 30000);
    const promise = (async () => {
      try {
        const response = await fetch(endpoint, { credentials: 'include', cache: 'no-store', signal: controller.signal, headers: { Accept: 'application/json' } });
        const data = await responseJson(response);
        if (version !== generation || controller.signal.aborted) throw new Error('wishlist_cancelled');
        if (data?.authenticated === false) { snapshot = null;updateHearts();return null; }
        if (!response.ok) throw new Error(errorCode(data));
        snapshot = validSnapshot(data);updateHearts();return snapshot;
      } finally {
        clearTimeout(timer);
        if (readController === controller) { readController = null;readPromise = null; }
      }
    })();
    readPromise = promise;return promise;
  }
  function setPanelState(text) { elements('[data-shoppa-wishlist-state]').forEach(node => { node.textContent = text; }); }
  async function mutate(productId, handle, removeOnly = false) {
    if (busy || !digitId.test(productId) || !handlePattern.test(handle)) return;
    const version = generation;busy = true;updateHearts();
    let submitted = false;
    try {
      const current = await load(true);
      if (version !== generation) return;
      if (!current) { await renderPanel();announce(copy.login, true);return; }
      const exists = current.items.some(item => item.product_id === productId);
      if (removeOnly && !exists) { await renderPanel();return; }
      const action = removeOnly || exists ? 'remove' : 'add';
      const controller = new AbortController();postController = controller;
      const timer = setTimeout(() => controller.abort(), 30000);
      try {
        submitted = true;
        const response = await fetch(endpoint, {
          method: 'POST', credentials: 'include', cache: 'no-store', signal: controller.signal,
          headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Shoppa-Wishlist-CSRF': current.csrf },
          body: JSON.stringify({ action, revision: current.revision, product_id: productId, handle })
        });
        const data = await responseJson(response);
        if (version !== generation || controller.signal.aborted) return;
        if (data?.authenticated === false) { reset();announce(copy.login, true);setPanelState(copy.login);return; }
        if (!response.ok) { submitted = false;throw new Error(errorCode(data)); }
        snapshot = validSnapshot(data);updateHearts();
        await renderPanel();
        if (version === generation) announce(action === 'add' ? copy.added : copy.removed);
      } finally { clearTimeout(timer);if (postController === controller) postController = null; }
    } catch (error) {
      if (version !== generation) return;
      const code = error.message;
      if (submitted) { snapshot = null;updateHearts();renderGeneration += 1;metadataController?.abort();elements('[data-shoppa-wishlist-list]').forEach(list => list.replaceChildren());elements('[data-shoppa-wishlist-more]').forEach(button => { button.hidden = true; });announce(copy.unconfirmed);setPanelState(copy.unconfirmed); }
      else if (code === 'wishlist_conflict') {
        announce(copy.conflict);
        try { await load(true);if (version === generation) await renderPanel(); } catch (_) { setPanelState(copy.error); }
      } else announce(code === 'wishlist_full' ? copy.full : copy.error);
    } finally { if (version === generation) { busy = false;updateHearts(); } }
  }
  function productUrl(handle) { return rootPath() + 'products/' + encodeURIComponent(handle); }
  function imageUrl(value) {
    if (typeof value !== 'string' || value.length > 8192) return null;
    try { const url = new URL(value, location.origin);return url.protocol === 'https:' && url.hostname === 'cdn.shopify.com' && !url.username && !url.password && !url.port ? url.href : null; } catch (_) { return null; }
  }
  async function readProduct(item, signal) {
    const key = item.product_id + ':' + item.handle;
    if (productCache.has(key)) return productCache.get(key);
    const response = await fetch(productUrl(item.handle) + '.js', { credentials: 'same-origin', cache: 'no-store', signal, headers: { Accept: 'application/json' } });
    const contentType = (response.headers.get('content-type') || '').split(';')[0].trim().toLowerCase();
    if (!response.ok || !['application/json', 'text/javascript', 'application/javascript'].includes(contentType)) throw new Error('product_unavailable');
    const raw = await response.text();if (raw.length > 2097152) throw new Error('product_unavailable');
    const data = JSON.parse(raw);
    if (!Number.isSafeInteger(data?.id) || String(data.id) !== item.product_id || typeof data.title !== 'string' || typeof data.available !== 'boolean' || !Number.isSafeInteger(data.price) || data.price < 0 || typeof data.price_varies !== 'boolean') throw new Error('product_unavailable');
    const product = { title: data.title, available: data.available, price: data.price, varies: data.price_varies, image: imageUrl(typeof data.featured_image === 'string' ? data.featured_image : '') };
    if (!signal.aborted) productCache.set(key, product);
    return product;
  }
  async function renderPanel() {
    const panels = elements('[data-shoppa-wishlist-panel]');
    if (!panels.length) return;
    const render = ++renderGeneration;
    const version = generation;
    metadataController?.abort();
    const controller = new AbortController();metadataController = controller;
    const active = () => render === renderGeneration && version === generation && !controller.signal.aborted;
    panels.forEach(panel => panel.setAttribute('aria-busy', 'true'));
    const timer = setTimeout(() => controller.abort(), 25000);
    const lists = elements('[data-shoppa-wishlist-list]');
    const previousFocus = document.activeElement;
    const replacingFocus = lists.some(list => list.contains(previousFocus));
    lists.forEach(list => list.replaceChildren());
    elements('[data-shoppa-wishlist-more]').forEach(button => { button.hidden = true; });
    try {
      if (!snapshot) { setPanelState(copy.login);return; }
      const items = snapshot.items.slice(0, visibleCount);
      setPanelState(items.length ? copy.loading : copy.empty);
      const targets = [];
      for (const list of lists) {
        for (const item of items) {
          const row = document.createElement('li');row.className = 'shoppa-wishlist-row';
          const image = document.createElement('span');image.className = 'shoppa-wishlist-image';image.setAttribute('aria-hidden', 'true');
          const content = document.createElement('div');
          const link = document.createElement('a');link.href = productUrl(item.handle);link.textContent = copy.loading;content.appendChild(link);
          const detail = document.createElement('p');content.appendChild(detail);
          const remove = document.createElement('button');remove.type = 'button';remove.dataset.shoppaWishlistRemove = '';remove.dataset.productId = item.product_id;remove.dataset.handle = item.handle;remove.className = 'shoppa-profile-test__button';remove.textContent = copy.remove;remove.disabled = busy;
          remove.addEventListener('click', () => { void mutate(item.product_id, item.handle, true); });
          row.append(image, content, remove);list.appendChild(row);targets.push({ item, row, image, link, detail, remove });
        }
      }
      let index = 0;
      async function worker() {
        while (index < targets.length && active()) {
          const target = targets[index++];
          try {
            const product = await readProduct(target.item, controller.signal);
            if (!active()) return;
            target.link.textContent = product.title;
            target.remove.setAttribute('aria-label', copy.remove + ': ' + product.title);
            // Ajax prices are in the customer's presentment currency, exposed by Shopify.currency.active.
            const currency = window.Shopify?.currency?.active || config.currency;
            if (!/^[A-Z]{3}$/.test(currency)) throw new Error('product_unavailable');
            const money = new Intl.NumberFormat(document.documentElement.lang || 'it-CH', { style: 'currency', currency, currencyDisplay: 'code' }).format(product.price / 100);
            target.detail.textContent = (product.varies ? copy.from + ' ' : '') + money + (product.available ? '' : ' · ' + copy.soldOut);
            if (product.image) {
              const img = document.createElement('img');img.src = product.image;img.alt = '';img.width = 64;img.height = 64;img.loading = 'lazy';img.referrerPolicy = 'no-referrer';target.image.appendChild(img);
            }
          } catch (_) {
            if (!active()) return;
            target.link.textContent = target.item.handle.replace(/-/g, ' ');
            target.detail.textContent = copy.productUnavailable;
          }
        }
      }
      await Promise.all(Array.from({ length: Math.min(3, targets.length) }, worker));
      if (!active()) return;
      setPanelState(snapshot.items.length ? copy.count.replace('[count]', String(snapshot.items.length)) : copy.empty);
      elements('[data-shoppa-wishlist-more]').forEach(button => { button.hidden = visibleCount >= snapshot.items.length; });
    } finally {
      clearTimeout(timer);
      if (render === renderGeneration && version === generation) {
        if (controller.signal.aborted) { setPanelState(copy.productUnavailable);elements('[data-shoppa-wishlist-list] a').forEach(link => { if (link.textContent === copy.loading) link.textContent = copy.productUnavailable; }); }
        panels.forEach(panel => panel.removeAttribute('aria-busy'));
        if (replacingFocus && previousFocus && !previousFocus.isConnected) document.querySelector('[data-shoppa-wishlist-refresh]')?.focus({ preventScroll: true });
        if (metadataController === controller) metadataController = null;
      }
    }
  }
  async function refreshPanel() {
    if (busy) return;
    setPanelState(copy.loading);
    try { await load(true);await renderPanel(); } catch (_) { setPanelState(copy.error); }
  }
  document.addEventListener('click', event => {
    const toggle = event.target.closest?.('[data-shoppa-wishlist-toggle]');
    if (toggle) { event.preventDefault();event.stopPropagation();void mutate(toggle.dataset.productId || '', toggle.dataset.handle || '');return; }
    const nav = event.target.closest?.('[data-profile-nav="wishlist"]');
    if (nav) void refreshPanel();
    if (event.target.closest?.('[data-shoppa-wishlist-refresh]')) void refreshPanel();
    if (!busy && event.target.closest?.('[data-shoppa-wishlist-more]')) { visibleCount += 12;void renderPanel(); }
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && notice) notice.hidden = true; });
  let scanFrame = null;
  const addedNodesObserver = new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.('[data-shoppa-wishlist-toggle]') || node.querySelector?.('[data-shoppa-wishlist-toggle]'))))) {
      if (scanFrame !== null) cancelAnimationFrame(scanFrame);
      scanFrame = requestAnimationFrame(() => { scanFrame = null;updateHearts(); });
    }
  });
  addedNodesObserver.observe(document.body, { childList: true, subtree: true });
  const profile = document.querySelector('[data-profile-bound]');
  if (profile) {
    const observer = new MutationObserver(() => {
      if (profile.dataset.profileAuthenticated !== 'true') reset();
      else void refreshPanel();
    });
    observer.observe(profile, { attributes: true, attributeFilter: ['data-profile-authenticated'] });
  }
  window.addEventListener('pagehide', reset);
  window.addEventListener('pageshow', event => { if (event.persisted) { reset();void load(true).catch(() => {}); } });
  window.ShoppaWishlist = { refresh: refreshPanel, reset };
  updateHearts();
  void load().then(() => renderPanel()).catch(() => { if (elements('[data-shoppa-wishlist-panel]').length) setPanelState(copy.error); });
}
